import ImportAPI from '@/apis/business/common/import-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
  },

  getters: {},

  mutations: {
  },

  actions: {
    /**
     * Xuất khẩu dữ liệu
     * @param {*} context
     * @param {*} param
     * @returns
     * @author BNDung
     */
    validate (context, param) {
      return new Promise((resolve, reject) => {
        ImportAPI.postAsync(`validate/${param?.fileID}/${param?.type}`)
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) {
              resolve(res.Data) // false = in ra nhiều sheet
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
